<template>
  <div>
    <!-- Wildcard selection -->
    <div v-if="lead.layout === 'ind-wildcard'">
      <div class="intro">
        <p>Want to do even more to combat climate change?</p>
        <p>
          Send a WWF Earth Hour Wildcard to a friend and challenge them to sign
          up and switch off for Earth Hour!
        </p>
      </div>

      <div class="wildcards-selector">
        <img
          src="https://www.earthhour.org.au/images/UserUploadedImages/624/EH-wildcards-animatedgif.gif"
        />
      </div>

      <div class="subtitle">
        <button type="button" v-on:click="sendWildcard()">
          Send a wildcard Now
        </button>
      </div>
    </div>

    <!-- Individual Donation -->
    <div class="donate-layout" v-if="lead.layout === 'ind-donation'">
      <div class="intro">
        <p>Want to do even more this Earth Hour?</p>
        <p>
          Donate to WWF’s Regenerate Australia campaign to support the plan to
          make Australia a Renewable Energy Exports Powerhouse.
        </p>
      </div>

      <div
        class="sign-img"
        :style="{
          'background-image': 'url(\'' + individualDonationBkgd + '\')',
        }"
      ></div>
      <div class="subtitle">
        <button type="button" v-on:click="donate()">Donate Now</button>
      </div>
    </div>

    <!-- Individual Petition -->
    <div class="donate-layout" v-if="lead.layout === 'ind-petition'">
      <div class="intro">
        <p>Want to do even more for nature this Earth Hour?</p>
        <p>
          In just 1 minute you can send a message to your local politician and
          urge them to stop the extinction crisis facing our Aussie wildlife.
        </p>
      </div>

      <div
        class="sign-img"
        :style="{
          'background-image': 'url(\'' + individualPetitionBkgd + '\')',
        }"
      ></div>
      <div class="subtitle">
        <button type="button" v-on:click="sign()">Take Action Now</button>
      </div>
    </div>

    <!-- Business Donation -->
    <div class="donate-layout" v-if="lead.layout === 'business'">
      <div class="intro">
        <p>Want to help more?</p>
        <p>Click this link and donate to our Renewable Nations campaign.</p>
      </div>
      <div
        class="sign-img"
        :style="{
          'background-image': 'url(\'' + businessDonationBkgd + '\')',
        }"
      ></div>
      <div class="subtitle">
        <button type="button" v-on:click="donate()">Donate Today</button>
      </div>
    </div>

    <!-- CTAs Schools -->
    <div class="ctas" v-if="lead.layout === 'school'">
      <!-- CTA 1 -->
      <div class="cta">
        <a
          href="https://www.coolaustralia.org/curriculum-materials/?types_k=&types_v=&year_level_k=&year_level_v=&ca_topic_k=ca_topic-wwf-earth-hour&ca_topic_v=12574&subject_k=&subject_v=&"
        >
          <h4>Free Earth Hour lesson plans</h4>
          <div
            class="img-container"
            :style="{
              'background-image': 'url(\'' + schoolCtaOne + '\')',
            }"
          ></div>
        </a>
      </div>

      <!-- CTA 2 -->
      <div class="cta">
        <a
          href="https://www.dropbox.com/sh/a41dt2mzfyk8v2f/AACRPZUkP8Ylf9OVYjSnQxsEa?dl=0"
        >
          <h4>Earth Hour info packs</h4>
          <div
            class="img-container"
            :style="{
              'background-image': 'url(\'' + schoolCtaTwo + '\')',
            }"
          ></div>
        </a>
      </div>

      <!-- CTA 3 -->
      <div class="cta">
        <a href="https://events.earthhour.org.au/">
          <h4>Host an event this Earth Hour</h4>
          <div
            class="img-container"
            :style="{
              'background-image': 'url(\'' + schoolCtaThree + '\')',
            }"
          ></div>
        </a>
      </div>
    </div>

    <!-- CTAs Communities -->
    <div class="ctas" v-if="lead.layout === 'community'">
      <!-- CTA 1 -->
      <div class="cta">
        <a href="https://www.earthhour.org.au/documents/social-assets ">
          <h4>Download your social media pack</h4>
          <div
            class="img-container"
            :style="{
              'background-image': 'url(\'' + communityCtaOne + '\')',
            }"
          ></div>
        </a>
      </div>

      <!-- CTA 2 -->
      <div class="cta">
        <a
          href="https://donate.wwf.org.au/donate/one-off-donation/renewables-nation"
        >
          <h4>Make a donation</h4>
          <div
            class="img-container"
            :style="{
              'background-image': 'url(\'' + communityCtaTwo + '\')',
            }"
          ></div>
        </a>
      </div>

      <!-- CTA 3 -->
      <div class="cta">
        <a href="https://events.earthhour.org.au/">
          <h4>Register your Earth Hour event</h4>
          <div
            class="img-container"
            :style="{
              'background-image': 'url(\'' + communityCtaThree + '\')',
            }"
          ></div>
        </a>
      </div>
    </div>

    <div class="outro" v-if="lead.layout !== 'school'">
      <a :href="mediaPackUrl">
        Spread the word and click here for exclusive access to your FREE social
        media bundle!
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "EarthhourPopup",
  data: function () {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      postCode: "",
      donateUrl: wwfconfigs.DONATEURL,
    };
  },

  props: {
    wildcardProductId: {
      type: String,
      default: "wildcards-illustrated-earthhour",
    },
    wildcardProductUrl: {
      type: String,
      default:
        "https://donate.wwf.org.au/wildcards/earth-hour/illustrated-designs",
    },
    donateProductUrl: {
      type: String,
      default:
        "https://donate.wwf.org.au/donate/one-off-donation/renewables-nation",
    },
    petitionUrl: {
      type: String,
      default:
        "https://www.wwf.org.au/get-involved/end-animal-extinction/end-animal-extinction-c",
    },
    mediaPackUrl: {
      type: String,
      default: "/documents/social-assets",
    },
    individualPetitionBkgd: {
      type: String,
      default:
        "https://www.earthhour.org.au/images/UserUploadedImages/624/img-white-greater-glider-in-tree-hollow.jpg",
    },
    individualDonationBkgd: {
      type: String,
      default:
        "https://www.earthhour.org.au/images/UserUploadedImages/624/Solar-installation.jpg",
    },
    businessDonationBkgd: {
      type: String,
      default:
        "https://www.earthhour.org.au/images/UserUploadedImages/624/Solar-installation.jpg",
    },
    schoolCtaOne: {
      type: String,
      default:
        "https://www.earthhour.org.au/images/UserUploadedImages/624/img-panda-mascote-in-school.jpg",
    },
    schoolCtaTwo: {
      type: String,
      default:
        "https://www.earthhour.org.au/images/UserUploadedImages/624/RSwwfau_2754_RSwwfau_2754.jpg",
    },
    schoolCtaThree: {
      type: String,
      default:
        "https://www.earthhour.org.au/images/UserUploadedImages/624/img-earth-hour-tree-planting.jpg",
    },
    communityCtaOne: {
      type: String,
      default:
        "http://earthhour-staging.wwf.org.au/images/UserUploadedImages/637/img-jasmine-earth-hour-mural-1000px.jpg",
    },
    communityCtaTwo: {
      type: String,
      default:
        "https://www.earthhour.org.au/images/UserUploadedImages/624/Solar-installation.jpg",
    },
    communityCtaThree: {
      type: String,
      default:
        "https://www.earthhour.org.au/Images/UserUploadedImages/626/img-crowd-filming-with-phone-1400x500.jpg",
    },
  },
  computed: {
    ...mapState({
      product: (state) => state.product.product,
      lead: (state) => state.earthHour,
      leadFirstName: (state) => state.earthHour.firstName,
      leadLastName: (state) => state.earthHour.lastName,
      leadEmail: (state) => state.earthHour.email,
      leadPhone: (state) => state.earthHour.phone,
      leadPostCode: (state) => state.earthHour.postCode,
    }),
  },

  watch: {
    leadFirstName(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.firstName = newVal;
      }
    },
    leadLastName(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.lastName = newVal;
      }
    },
    leadEmail(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.email = newVal;
      }
    },
    leadPhone(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.phone = newVal;
      }
    },
    leadPostCode(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.postCode = newVal;
      }
    },
  },

  methods: {
    sendWildcard() {
      let query = `firstname=${this.firstName}`;
      query += `&lastname=${this.lastName}`;
      query += `&email=${this.email}`;
      query += `&source=${document.URL}`;

      let params = "?q=" + window.btoa(query);

      try {
        const gaTag = ga.getAll()[0].get("linkerParam");
        if (gaTag) {
          params += `&${gaTag}`;
        }
      } catch (err) {
        console.error(err);
      }

      const url = this.wildcardProductUrl + params;

      window.open(url, "_self");
    },
    donate() {
      let query = `firstname=${this.firstName}`;
      query += `&lastname=${this.lastName}`;
      query += `&email=${this.email}`;
      query += `&source=${document.URL}`;

      let params = "?q=" + window.btoa(query);

      try {
        const gaTag = ga.getAll()[0].get("linkerParam");
        if (gaTag) {
          params += `&${gaTag}`;
        }
      } catch (err) {
        console.error(err);
      }

      const url = this.donateProductUrl + params;
      window.open(url, "_self");
    },
    sign() {
      let query = `firstname=${this.firstName}`;
      query += `&lastname=${this.lastName}`;
      query += `&email=${this.email}`;
      query += `&phone=${this.phone}`;
      query += `&postcode=${this.postCode}`;

      let params = "?q=" + window.btoa(query);
      params += `&o=earth-hour`;
      params += `&type=epbc`;

      try {
        const gaTag = ga.getAll()[0].get("linkerParam");
        if (gaTag) {
          params += `&${gaTag}`;
        }
      } catch (err) {
        console.error(err);
      }
      const url = this.petitionUrl + params;

      window.open(url, "_self");
    },
  },
};
</script>

<style scoped>
.intro,
.outro {
  width: 100%;
  margin: 14px 0;
  padding: 0 6px;
  text-align: center;
  color: var(--wwfWhite);
}

.intro p {
  margin: 6px 0;
  font-size: 20px;
}

.intro a,
.outro a {
  font-size: 18px;
}

.intro a:hover,
.outro a:hover {
  color: var(--wwfWhite);
}

.wildcards-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  min-height: 200px;
  width: 100%;
}

.wildcard-card {
  flex-grow: 1;
  margin: 5px;
  padding: 5px;
  height: 100%;
  min-width: 200px;
  max-width: 350px;
  cursor: pointer;
}

.wildcard-card.active {
  border: 3px solid var(--wwfBlue);
  border-radius: 5px;
}

.wildcard-content {
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.subtitle {
  width: 100%;
  margin: 16px 0;
  text-align: center;
  font-size: 24px;
  color: var(--wwfWhite);
}

.subtitle button {
  margin: 16px;
  padding: 16px 24px;
  background-color: var(--wwfBlue);
  color: var(--wwfWhite);
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
}

.ctas {
  display: flex;
  justify-content: space-evenly;

  flex-wrap: wrap;
}

.cta {
  flex: 1;
  padding: 25px;
  width: 33.33%;
  max-height: 400px;
}

.cta h4 {
  margin-bottom: 12px;
  font-size: 20px;
  text-align: center;
  white-space: nowrap;
  color: var(--wwfWhite);
}

.cta .img-container {
  margin: 0 auto;
  width: 100%;
  min-height: 200px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.cta img {
  width: 100%;
  height: 100%;
}

@media only screen and (max-width: 1050px) {
  .cta {
    width: 100%;
    flex-basis: 100%;
  }
}

.sign-img {
  height: 250px;
  margin: 12px 16px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.ind-donate-img {
  background-image: url("http://earthhour-staging.wwf.org.au/images/UserUploadedImages/637/img-jasmine-earth-hour-mural-1000px.jpg");
}

.petition-img {
  background-image: url("http://earthhour-staging.wwf.org.au/images/UserUploadedImages/637/img-jasmine-earth-hour-mural-1000px.jpg");
}

.donate-img {
  background-image: url("http://earthhour-staging.wwf.org.au/images/UserUploadedImages/637/img-jasmine-earth-hour-mural-1000px.jpg");
}
</style>


// WEBPACK FOOTER //
// EarthhourPopup.vue?c426f6aa